import React from 'react';
import { Typography } from '@/UIlibrary/Typography/Typography';
import { useTranslations } from 'use-intl';
import { Registry, PaymentStatus, TrialType } from '@/graphql/__generated__/onboarding';
import { formatMoneyValue, formatPercentageValue } from '@/utils/utils';
import { TrialTypeMap } from '@/utils/maps';

interface CreditBureauSummaryProps {
	registry: Registry;
}

const CreditBureauSummary: React.FC<CreditBureauSummaryProps> = ({ registry }) => {
	const t = useTranslations('RegistryDetails');
	const tJury = useTranslations('JuryTypes');

	const getTranslatedTrials = () => {
		if (!registry?.creditSummaryBureauReport?.trials) return '';

		const translatedTrials = registry.creditSummaryBureauReport.trials
			.filter((trial) => trial)
			.map((trial) => {
				const trialKey = TrialTypeMap[trial as TrialType] || '';
				return tJury(trialKey as any) || trialKey;
			});

		return translatedTrials.join(', ');
	};

	if (!registry?.creditSummaryBureauReport?.accounts) return null;

	const totalAccounts = registry?.creditSummaryBureauReport?.accounts.filter(
		(account) => account?.paymentStatus === PaymentStatus.CODE_TOTAL
	);
	const translatedTrials = getTranslatedTrials();

	const TextItem: React.FC<{ title: string; value: string | number }> = ({ title, value }) => {
		return (
			<div className="flex flex-row gap-2">
				<Typography size="sm" weight="semibold">
					{title}
				</Typography>
				<Typography size="sm">{value}</Typography>
			</div>
		);
	};

	return (
		<div className="flex flex-col gap-2">
			<TextItem
				title={t('DefaultProbability')}
				value={formatPercentageValue(registry.creditBureauDefaultScore?.toString() || '0')}
			/>
			<TextItem
				title={t('OpenAccountsCurrentBalance')}
				value={formatMoneyValue(totalAccounts?.[0]?.openAccounts?.currentBalance)}
			/>
			<TextItem
				title={t('OpenAccountsDueBalance')}
				value={formatMoneyValue(totalAccounts?.[0]?.openAccounts?.amount)}
			/>
			<TextItem
				title={t('ClosedAccountsMaximumBalance')}
				value={formatMoneyValue(totalAccounts?.[0]?.closedAccounts?.maximumBalance)}
			/>
			<TextItem
				title={t('OpenAccountsMonthlyPayment')}
				value={formatMoneyValue(totalAccounts?.[0]?.openAccounts?.monthlyPayment)}
			/>
			{registry?.creditSummaryBureauReport?.totalTrials && (
				<TextItem
					title={t('Jury')}
					value={`${registry?.creditSummaryBureauReport?.totalTrials} ${translatedTrials}`}
				/>
			)}
		</div>
	);
};

export default CreditBureauSummary;
